import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  card: {
    display: 'flex',
    padding: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignSelf: 'stretch',
  },
  cardTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 8,
    marginLeft: '3px',
  },
  chevronButton: {
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: 8,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  cloudLogo: {
    height: 24,
    width: 'auto',
  },
  divider: {
    height: 1,
    background: theme.palette.divider,
    width: '100%',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: theme.spacing(1.5),
    rowGap: theme.spacing(1.5),
    width: '100%',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    width: '100%',
  },
  metaLabel: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.shadows.light,
  },
  metaValue: {
    color: theme.palette.shadows.dark,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    minHeight: '20px',
    width: theme.spacing(25),
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    justifyContent: 'flex-start',
    height: theme.spacing(3),
  },
  statusItem: {
    color: theme.palette.text.primary,
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
  },
  errorText: {
    color: theme.palette.error.main,
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    marginTop: theme.spacing(-0.5),
  },
  linkIcon: {
    color: theme.palette.select.light,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 8,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: 4,
    '&:hover': {
      opacity: 0.8,
    },
  },
  copyLinkIcon: {
    color: theme.palette.select.light,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 1,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: 4,
    '&:hover': {
      opacity: 0.8,
    },
  },
  expiredText: {
    color: theme.palette.error.dark,
    display: 'inline',
  },
  expiryDateTexts: {
    display: 'inline',
  },
  expiryDateValue: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  chevronIcon: {
    transform: 'none',
    transition: 'transform 120ms ease',
  },
  chevronIconCollapsed: {
    transform: 'rotate(180deg)',
    transition: 'transform 120ms ease',
  },
  tcvText: {
    color: theme.palette.labraText.description,
    fontWeight: 400,
    fontFamily: 'Poppins',
    fontSize: '12px',
    lineHeight: theme.spacing(2),
  },
  tcvLabel: {
    color: theme.palette.labraText.description,
    fontWeight: 400,
    fontFamily: 'Poppins',
    fontSize: '14px',
    lineHeight: theme.spacing(2.5),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(-0.5),
  },
}))
